import React from 'react';
import { platformFeatures } from '../mock';

const PlatformSection = () => (
  <section id="platform" className="py-24 lg:py-32 border-t border-border">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16">
      <div className="lg:sticky lg:top-28 self-start">
        <div className="section-label mb-4">Platform</div>
        <h2 className="font-display text-4xl lg:text-5xl font-bold leading-[1.1] tracking-tight text-foreground">
          Controlled digital certificates for <span className="gradient-text">compliant asset tokenization</span>
        </h2>
        <p className="mt-6 text-lg text-muted-foreground leading-relaxed max-w-md">
          Tangibl3Net helps issuers, fiduciaries, producers, NGOs, and asset sponsors convert documented rights into controlled digital certificates with wallet settlement, beneficiary ledgers, transfer restrictions, and audit-ready files.
        </p>
      </div>

      <div className="space-y-4">
        {platformFeatures.map((f) => (
          <div key={f.title} className="group p-6 rounded-2xl border border-border bg-card hover:border-primary/40 hover:shadow-lg hover:shadow-slate-900/5 transition-all duration-300">
            <div className="flex items-start gap-4">
              <div className="w-11 h-11 shrink-0 rounded-xl bg-primary/10 flex items-center justify-center group-hover:bg-primary/15 transition-colors">
                <f.icon className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h3 className="font-display text-lg font-semibold text-foreground">{f.title}</h3>
                <p className="mt-1.5 text-[15px] text-muted-foreground leading-relaxed">{f.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default PlatformSection;
